<template lang="html">
  <b-card>
    <div slot="header">{{ user.name }}</div>
    <div class="form-group row">
      <label for="cpf" class="col-sm-4 col-form-label">CPF</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="cpf" :value="user.cpf">
      </div>
    </div>
    <div class="form-group row">
      <label for="endereco" class="col-sm-4 col-form-label">Rua, número</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="endereco" :value="shipping.address.street + ', ' + shipping.address.number">
      </div>
    </div>
    <div class="form-group row">
      <label for="complemento" class="col-sm-4 col-form-label">Complem. (Bairro)</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="complemento" :value="shipping.address.complement + ' (' + shipping.address.district + ')' ">
      </div>
    </div>

    <div class="form-group row">
      <label for="cep" class="col-sm-4 col-form-label">Cep</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="cep" :value="shipping.address.zip">
      </div>
    </div>

    <div class="form-group row">
      <label for="cidade" class="col-sm-4 col-form-label">Cidade</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="cidade" :value="shipping.address.city + ' (' + shipping.address.state + ')'">
      </div>
    </div>
    <!--<div class="form-group row" v-if="validation">-->
      <!--<label for="telefone" class="col-sm-4 col-form-label">Telefone {{validation.phoneNumberValidated ? 'Confirmado' : 'Não confirmado'}} <a :href="'https://api.whatsapp.com/send?phone=55' + validation.phoneNumberConfirmed" target="_blank"><i class="micon-whatsapp"></i></a></label>-->
      <!--<div class="col-sm-8">-->
        <!--<input type="text" readonly class="form-control-plaintext" id="telefoneConfirmado" :value="validation.phoneNumberConfirmed">-->
      <!--</div>-->
    <!--</div>-->
    <hr>
    <div class="form-group row">
      <label for="telefone" class="col-sm-4 col-form-label">Telefone (E-commerce) <a :href="'https://api.whatsapp.com/send?phone=55' + user.phoneNumber" target="_blank"><i class="micon-whatsapp"></i></a></label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="telefone" :value="user.phoneNumber">
      </div>
    </div>
    <phone-manager-component></phone-manager-component>
    <hr>
    <div class="form-group row">
      <label for="email" class="col-sm-4 col-form-label">E-mail (E-commerce)</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="email" :value="user.email">
      </div>
    </div>

    <email-manager-component :user="user" :tx="tx" :reference="reference"></email-manager-component>
  </b-card>
</template>
<script>
import ContactPhoneManager from '../contacts/ContactPhoneManager.vue'
import ContactEmailManager from '../contacts/ContactEmailManager.vue'

export default {
  props: ['user', 'shipping', 'validation', 'reference', 'tx'],
  components: {
    'phone-manager-component': ContactPhoneManager,
    'email-manager-component': ContactEmailManager
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/users/UserDetails.vue